import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 16.885C12.1091 16.885 12.2129 16.8617 12.3064 16.8198L12.4967 16.6973C12.5084 16.6869 12.5199 16.6762 12.5311 16.665L16.78 12.4161C17.0733 12.1227 17.0733 11.6472 16.78 11.3538C16.4867 11.0605 16.0111 11.0605 15.7178 11.3538L12.7511 14.3205V3.38715C12.7511 2.97233 12.4148 2.63605 12 2.63605C11.5852 2.63605 11.2489 2.97233 11.2489 3.38715V14.3205L8.28222 11.3538C7.98889 11.0605 7.51332 11.0605 7.21999 11.3538C6.92667 11.6472 6.92667 12.1227 7.21999 12.4161L11.4689 16.665L11.4705 16.6666C11.5401 16.7357 11.6198 16.7884 11.7049 16.8248C11.7955 16.8635 11.8952 16.885 12 16.885Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.49998 13C3.49998 12.5858 3.1642 12.25 2.74998 12.25C2.33577 12.25 1.99998 12.5858 1.99998 13V18.23C1.99998 20.3101 3.68849 21.993 5.76967 21.9826C9.03211 21.9663 14.2874 21.9473 18.1944 21.9688C20.2836 21.9803 22 20.2941 22 18.1967V13C22 12.5858 21.6642 12.25 21.25 12.25C20.8358 12.25 20.5 12.5858 20.5 13V18.1967C20.5 19.4543 19.4684 20.4758 18.2026 20.4688C14.287 20.4473 9.02481 20.4663 5.76216 20.4826C4.51347 20.4889 3.49998 19.4799 3.49998 18.23V13Z",
		fill: "currentColor"
	})]
});
export { SvgIconDownload as ReactComponent };
